module.exports = __webpack_public_path__ + "img/Android_symbol_green_RGB 2.f0041d65.svg";